import request from '../../utils/request'

// 查询
export function fetchList (data) {
  return request.post('/business/parkBook/page', data, {
    trim: true
  })
}

// 创建
export function create (data) {
  return request.post('/business/parkBook/create', data)
}

// 修改
export function updateById (data) {
  return request.post('/business/parkBook/updateById', data)
}
// 修改
export function reUpdate (data) {
  return request.post('/business/parkBook/reUpdate', data)
}

// 删除
export function deleteById (id) {
  return request.get(`/business/parkBook/delete/${id}`)
}

// 批量删除
export function deleteByIdInBatch (ids) {
  return request.get('/business/parkBook/delete/batch', {
    params: {
      ids
    }
  })
}
